import React from 'react';
import Feature from './Feature';
import './Features.css';
import icon2 from '../../../images/whychooseus/icon/link.webp'
import icon1 from '../../../images/whychooseus/icon/local.webp'
import icon3 from '../../../images/whychooseus/icon/map.webp'
import icon4 from '../../../images/whychooseus/icon/paid.webp'

const featureData = [
    {
        id:1,
        icon: icon1,
        title: 'Local Search History',
        description: 'Maximize your presence on search engine results pages on a local scale.'
    },
    {
        id:2,
        icon: icon3,
        title: 'Map Search Optimization',
        description: 'Google Maps Optimization is an important part for your local marketing strategy.'
    },
    {
        id:3,
        icon: icon2,
        title: 'Link Building and Content',
        description: 'Link building is a tremendously important component of Search Engine Optimization.'
    },
    {
        id:4,
        icon: icon1,
        title: 'Paid Search Advertising',
        description: 'Paid listings on Google AdWords can help you reach new customers.'
    }
]

function Features() {
    return (
        <div className="features-container   m-auto">
            <div className="text-center pt-5">
                <h4 style={{fontWeight:'300', marginBottom:'10px'}}>WHY CHOOSE US</h4>
                <h2 style={{fontSize:'45px'}}>FEATURES</h2>
            </div>
            <div className="row  m-auto">
                {
                    featureData.map(data =><Feature data={data} key={featureData.id}></Feature>)
                }
            </div>

            <div className="text-center mt-5">
                <p style={{fontWeight:'600'}}>Increase your business success with technology. <a href="">Let’s get started</a></p>
            </div>
        </div>
    )
}

export default Features
